import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';

export default function dayjsToDate(date: Dayjs | undefined): Date {
  return dayjs(date).toDate();
}
